// Geração dos payloads de pagamento direto (sem intermediário).
// Pix: BR Code (EMV/Bacen). Europa: EPC QR (EPC069-12, transferência SEPA).

function ascii(input: string, max: number): string {
  return input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^\x20-\x7E]/g, '')
    .trim()
    .slice(0, max);
}

function crc16(payload: string): string {
  let crc = 0xffff;
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = crc & 0x8000 ? (crc << 1) ^ 0x1021 : crc << 1;
      crc &= 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}

// id + comprimento (2 dígitos) + valor
function tlv(id: string, value: string): string {
  return id + value.length.toString().padStart(2, '0') + value;
}

export interface PixInput {
  key: string;
  merchantName: string;
  city: string;
  amountCents: number;
  reference?: string;
}

export function buildPixPayload(p: PixInput): string {
  const amount = (p.amountCents / 100).toFixed(2);
  const merchantAccount = tlv('00', 'br.gov.bcb.pix') + tlv('01', p.key.trim());
  const ref = ascii((p.reference ?? '').replace(/[^a-zA-Z0-9]/g, ''), 25) || '***';
  const additional = tlv('05', ref);

  let payload =
    tlv('00', '01') +
    tlv('01', '11') + // estático (com valor); o garçom confirma o recebimento
    tlv('26', merchantAccount) +
    tlv('52', '0000') +
    tlv('53', '986') + // BRL
    tlv('54', amount) +
    tlv('58', 'BR') +
    tlv('59', ascii(p.merchantName || 'RECEBEDOR', 25)) +
    tlv('60', ascii(p.city || 'CIDADE', 15)) +
    tlv('62', additional);

  payload += '6304';
  return payload + crc16(payload);
}

export interface SepaInput {
  iban: string;
  name: string;
  amountCents: number;
  remittance?: string;
}

// EPC069-12 v002 — o app bancário do cliente lê e pré-preenche a transferência SEPA.
export function buildSepaPayload(s: SepaInput): string {
  const amount = 'EUR' + (s.amountCents / 100).toFixed(2);
  return [
    'BCD',
    '002',
    '1',
    'SCT',
    '', // BIC (opcional na v002)
    ascii(s.name, 70),
    s.iban.replace(/\s+/g, '').toUpperCase(),
    amount,
    '', // purpose
    '', // structured remittance
    ascii(s.remittance ?? '', 140),
    '' // beneficiary to originator
  ].join('\n');
}
